import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Login from '../pages/login/Login';
import Registration from '../pages/registration/Registration';
import React from 'react';
import ForgotPassword from '../pages/fogotPassword/ForgotPassword';
import CompanyRegistrationForm from '../pages/companyAndBURegistration/CompanyRegistrationForm';
import PinkMenu from './layout/PinkMenu';
import { Box } from '@mui/material';
import Groups from '../pages/groups/Groups';
import ProductList from '../pages/products/ProductList';
import ProductForm from '../pages/products/ProductForm';

const RoutedApp = () => {
  const location = useLocation();
  const hideMenuPaths = ['/login'];

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {!hideMenuPaths.includes(location.pathname) && <PinkMenu />}
      <Box sx={{
        flexGrow: 1,
        paddingTop: { xs: '48px', sm: 0 }
      }}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/companyRegistration" element={<CompanyRegistrationForm />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/create" element={<ProductForm mode={'create'} />} />
          <Route path="/products/update/:id" element={<ProductForm mode={'update'} />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default RoutedApp;
